module.exports = __webpack_public_path__ + "static/Zeus Technology-5c6d1c8bdf3e8e83a930a3a72d1ff01e.svg";